// savedDeploymentConfirmation.tsx
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React from 'react'
import { ConfirmationDialogBox } from '../../../components/ConfirmationDialogBox'

export interface OwnProps {
  open: boolean
  onConfirm: () => void
}

export function SavedDeploymentConfirmation(
  {
    open,
    onConfirm
  }: Readonly<OwnProps>
): JSX.Element {
  return (
    <ConfirmationDialogBox
      open={open}
      title="Deployment Saved"
      description="The Solution Set configuration has been sent to the selected sites. To view, please navigate to each site on the Monitoring dashboard."
      onConfirm={onConfirm}
      buttonText="OK"
    />
  )
}
